import React from 'react'
import Navigation from '../../Component/Navigation/Navigation'
import Footer from '../../Component/Footer/Footer'

export default function PrivacyPolicy() {
  return (
    <div >
        <Navigation/>
          <div class="about-header about">
      <div class="header-container">
        <h1 class="about-title abouth1">Privacy Policy</h1>
        <h3 class="about-title abouth3">Home/ Privacy Policy</h3>
      </div>
    </div>
    <div class="section-policy">
      Privacy Policy Effective Date: This Privacy Policy explains how {process.env.REACT_APP_APP_NAME}
      ("we," "us," or "our") collects, uses, and discloses information about you
      when you use our website, mobile application, and other online services
      (collectively, the "Services"). Information We Collect Personal
      Information: We may collect personal information from you, such as your
      name, email address, phone number, and any other information you provide
      to us when you use our Services. Usage Information: We may collect
      information about how you use our Services, including your IP address,
      browser type, device information, and the pages you visit. Financial
      Information: If you request a refund or make a payment through our
      Services, we may collect your bank account information, credit/debit card
      details, and other financial information necessary to process the
      transaction. How We Use Your Information To Provide and Improve Our
      Services: We use the information we collect to provide, maintain, and
      improve our Services, as well as to develop new features and
      functionality. To Communicate with You: We may use your information to
      respond to your inquiries, send you updates, and provide customer support.
      To Comply with Legal Obligations: We may use your information to comply
      with applicable laws, regulations, and legal processes. How We Share Your
      Information Service Providers: We may share your information with
      third-party service providers who assist us in operating and improving our
      Services, such as payment processors, cloud storage providers, and
      analytics providers. Legal Compliance: We may share your information with
      law enforcement, government agencies, or other third parties as required
      by applicable law or to protect our rights or the rights of others.
      Business Transfers: In the event of a merger, acquisition, or other
      corporate reorganization, we may transfer your information to the new
      entity. Data Security We implement reasonable security measures to protect
      the confidentiality, integrity, and availability of your information.
      However, no method of transmission or storage is 100% secure, and we
      cannot guarantee the absolute security of your information. Your Choices
      and Rights Access and Update: You may access, review, and update your
      personal information by contacting us at [support@capitalfinedge.com]. Opt-Out:
      You may opt-out of receiving promotional communications from us by
      following the unsubscribe instructions provided in the communication or by
      contacting us. Data Deletion: You may request the deletion of your
      personal information by contacting us, subject to certain exceptions and
      limitations. Changes to this Privacy Policy We may update this Privacy
      Policy from time to time. We will post the updated policy on our website
      and indicate the effective date of the changes. Contact Us If you have any
      questions or concerns about our Privacy Policy or the way we handle your
      information, please contact us at support@capitalfinedge.com.
    </div>
    <Footer />
    </div>
  )
}
